import { render, staticRenderFns } from "./EmptyBody.vue?vue&type=template&id=63978652&"
import script from "./EmptyBody.vue?vue&type=script&lang=js&"
export * from "./EmptyBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports